import React from 'react';
import { StatCard } from './components/StatCard';
import { useDashboardStats } from './hooks/useDashboardStats';

export const StartDashboardPage: React.FC = () => {
  const { stats, isPending } = useDashboardStats();

  const cards: Array<{
    key: string;
    title: string;
    value: number | string | null;
    to: string;
    accentColor: string;
  }> = [
    {
      key: 'pages',
      title: 'Pages',
      value: stats ? stats.pages : null,
      to: '/page-management/pages',
      accentColor: '#47be7d',
    },
    {
      key: 'posts',
      title: 'Posts',
      value: stats ? stats.posts : null,
      to: '/post-management/posts',
      accentColor: '#7239ea',
    },
    {
      key: 'users',
      title: 'Users',
      value: stats ? stats.users : null,
      to: '/user-management/members',
      accentColor: '#f1502f',
    },
    {
      key: 'files',
      title: 'Files',
      value: stats ? stats.files : null,
      to: '/media-management/media-library',
      accentColor: '#00a3ff',
    },
    {
      key: 'quotations',
      title: 'Quotations',
      value: stats ? stats.quotes : null,
      to: '/quotation-management/quotations',
      accentColor: '#f1bc00',
    },
  ];

  return (
    <div className="row g-0 g-xl-5 g-xxl-8">
      {cards.map((card) => (
        <div key={card.key} className="col-md-6 col-xl-4">
          <StatCard
            title={card.title}
            value={card.value}
            to={card.to}
            accentColor={card.accentColor}
            isPending={isPending}
          />
        </div>
      ))}
    </div>
  );
};
